import {ISalaryScheme, SalarySchemeResponseType} from "@/entity/salaryScheme/salaryScheme.types";

export default class SalaryScheme implements ISalaryScheme {
    id: number;
    name: string;
    type: boolean;
    constructor(data: SalarySchemeResponseType) {
        this.id = data.id;
        this.name = data.name;
        this.type = data.type;
    }
}